const PRODUCT_BREADCRUMB_STORAGE_KEY = 'lolo:product-breadcrumb-source';

function getProductHandle(urlValue) {
  try {
    const url = new URL(urlValue, window.location.origin);

    if (url.origin !== window.location.origin) return '';

    const match = url.pathname.match(/\/products\/([^/]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  } catch (error) {
    return '';
  }
}

function getCollectionUrl(urlValue) {
  try {
    const url = new URL(urlValue, window.location.origin);

    if (url.origin !== window.location.origin || !url.pathname.includes('/collections/')) return '';

    return `${url.pathname}${url.search}`;
  } catch (error) {
    return '';
  }
}

function saveProductBreadcrumbSource(event) {
  const productLink = event.target.closest('a[href*="/products/"]');
  const source = productLink?.closest('[data-product-breadcrumb-source]');

  if (!productLink || !source) return;

  const productHandle = getProductHandle(productLink.href);
  const collectionTitle = source.dataset.collectionTitle?.trim();
  const collectionUrl = getCollectionUrl(source.dataset.collectionUrl);

  if (!productHandle || !collectionTitle || !collectionUrl) return;

  try {
    localStorage.setItem(
      PRODUCT_BREADCRUMB_STORAGE_KEY,
      JSON.stringify({ productHandle, collectionTitle, collectionUrl })
    );
  } catch (error) {
    // localStorage can be unavailable in privacy modes. Liquid remains the fallback.
  }
}

function getSavedProductBreadcrumb(productHandle) {
  try {
    const savedBreadcrumb = JSON.parse(localStorage.getItem(PRODUCT_BREADCRUMB_STORAGE_KEY) || 'null');

    if (!savedBreadcrumb || savedBreadcrumb.productHandle !== productHandle) return null;

    const collectionTitle = savedBreadcrumb.collectionTitle?.trim();
    const collectionUrl = getCollectionUrl(savedBreadcrumb.collectionUrl);

    if (!collectionTitle || !collectionUrl) return null;

    return { collectionTitle, collectionUrl };
  } catch (error) {
    return null;
  }
}

function applySavedProductBreadcrumb(root = document) {
  root.querySelectorAll('.pdp-breadcrumbs[data-product-handle]').forEach((breadcrumb) => {
    const savedBreadcrumb = getSavedProductBreadcrumb(breadcrumb.dataset.productHandle);

    if (!savedBreadcrumb) return;

    let collectionItem = breadcrumb.querySelector('.pdp-breadcrumbs__collection');
    const currentItem = breadcrumb.querySelector('.pdp-breadcrumbs__current');

    if (!currentItem) return;

    if (!collectionItem) {
      collectionItem = document.createElement('li');
      collectionItem.className = 'breadcrumb__list-item pdp-breadcrumbs__collection';
      collectionItem.append(document.createElement('a'));
      currentItem.before(collectionItem);
    }

    const collectionLink = collectionItem.querySelector('a');
    collectionLink.href = savedBreadcrumb.collectionUrl;
    collectionLink.textContent = savedBreadcrumb.collectionTitle;
  });
}

document.addEventListener('click', saveProductBreadcrumbSource, true);
document.addEventListener('auxclick', saveProductBreadcrumbSource, true);
document.addEventListener('DOMContentLoaded', () => applySavedProductBreadcrumb());
document.addEventListener('shopify:section:load', (event) => applySavedProductBreadcrumb(event.target));
document.addEventListener('product:rerender', () => requestAnimationFrame(() => applySavedProductBreadcrumb()));

